import React, { useState } from "react";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { useLang } from "../context/LanguageContext";

const QuoteForm = ({ source = "contact_page", calculatorData = null }) => {
  const { t } = useLang();
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = { ...form, source, ...(calculatorData || {}) };
      await api.post("/leads", payload);
      setDone(true);
      toast.success(t.contact.success);
    } catch (err) {
      toast.error(t.contact.error);
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div className="bg-white rounded-3xl border border-brand/30 p-10 text-center shadow-[0_30px_80px_rgba(255,47,125,0.12)]" data-testid="quote-form-success">
        <div className="w-16 h-16 rounded-full bg-brand-soft mx-auto flex items-center justify-center mb-5">
          <CheckCircle2 className="text-brand" size={32} />
        </div>
        <h3 className="font-heading text-2xl font-black text-navy-900 mb-2">{t.contact.success}</h3>
        <p className="text-slate-600">Onze adviseur belt je binnen 24 uur op het opgegeven nummer.</p>
      </div>
    );
  }

  return (
    <form onSubmit={onSubmit} className="bg-white rounded-3xl border border-slate-200 p-7 lg:p-9 shadow-[0_30px_80px_rgba(15,23,42,0.05)] space-y-4" data-testid="quote-form">
      <div className="grid sm:grid-cols-2 gap-4">
        <Field label={t.contact.name} name="name" value={form.name} onChange={onChange} required />
        <Field label={t.contact.email} name="email" type="email" value={form.email} onChange={onChange} required />
      </div>
      <Field label={t.contact.phone} name="phone" type="tel" value={form.phone} onChange={onChange} required />
      <div>
        <label className="text-sm font-semibold text-navy-900 mb-2 block">{t.contact.message}</label>
        <Textarea name="message" value={form.message} onChange={onChange} rows={4} className="rounded-xl border-slate-200" data-testid="quote-message" />
      </div>
      <button type="submit" disabled={loading} className="btn-pink w-full !py-4 disabled:opacity-60" data-testid="quote-submit">
        {loading ? "Versturen..." : t.contact.submit} {!loading && <ArrowRight size={16} />}
      </button>
      <p className="text-xs text-slate-500 text-center">Door te versturen ga je akkoord met onze privacyverklaring.</p>
    </form>
  );
};

const Field = ({ label, name, type = "text", value, onChange, required }) => (
  <div>
    <label className="text-sm font-semibold text-navy-900 mb-2 block">{label}{required && <span className="text-brand"> *</span>}</label>
    <Input type={type} name={name} value={value} onChange={onChange} required={required} className="rounded-xl h-12 border-slate-200 focus-visible:ring-brand" data-testid={`quote-${name}`} />
  </div>
);

export default QuoteForm;
